<template>
    <DropDownButton
        :classes-prop="`header-dropdown`"
        btn-classes-prop="c-header__link"
        :is-header-dropdown="true"
    >
        <template #title>
            <span>Teacher</span>
        </template>
        <template #items>
            <ul>
                <li>
                    <a :href="competitionLink" target="_blank" rel="noopener">
                        Masters League Competition
                    </a>
                </li>
                <li>
                    <a :href="fbGroupLink" target="_blank" rel="noopener">
                        Join Facebook community
                    </a>
                </li>
                <li>
                    <a :href="blogLink" target="_blank" rel="noopener">Blog</a>
                </li>
                <li>
                    <a :href="supportLink" target="_blank" rel="noopener">
                        Support
                    </a>
                </li>
            </ul>
        </template>
    </DropDownButton>
</template>
<script>
import DropDownButton from '@/core/ui/_legacy/DropDownButton.vue';
import { getFbGroupLink } from '@/core/helpers/utils';
import { mapGetters } from 'vuex';

export default {
    components: { DropDownButton },
    computed: {
        ...mapGetters({
            currentLanguage: 'getCurrentLanguage',
        }),
        fbGroupLink() {
            return getFbGroupLink(this.currentLanguage);
        },
        parentsPageLink() {
            return 'https://parents.99math.com/';
        },
        blogLink() {
            return 'https://www.blog.99math.com/';
        },
        supportLink() {
            return 'https://support.99math.com/support/solutions';
        },
        competitionLink() {
            return `${window.location.origin}/public-monthly-competition`;
        },
    },
};
</script>
<style lang="scss">
@use '@/scss/components/_components.header-dropdown.scss';
</style>
